import React from 'react';

const AllRouteDataContext = React.createContext({
    allRoutes: [],
    setAllRoutes: () => {}
});


export default AllRouteDataContext;